import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_OVERWRITE_DEFAULT_UI_BEGIN,
  APP_SETTING_OVERWRITE_DEFAULT_UI_SUCCESS,
  APP_SETTING_OVERWRITE_DEFAULT_UI_FAILURE,
  APP_SETTING_OVERWRITE_DEFAULT_UI_DISMISS_ERROR,
} from './constants';

export function overwriteDefaultUi(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_OVERWRITE_DEFAULT_UI_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/custom-themeProps`,
        args.themeProps,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_OVERWRITE_DEFAULT_UI_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_OVERWRITE_DEFAULT_UI_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissOverwriteDefaultUiError() {
  return {
    type: APP_SETTING_OVERWRITE_DEFAULT_UI_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_OVERWRITE_DEFAULT_UI_BEGIN:
      return {
        ...state,
        overwriteDefaultUiPending: true,
        overwriteDefaultUiError: null,
      };

    case APP_SETTING_OVERWRITE_DEFAULT_UI_SUCCESS:
      return {
        ...state,
        overwriteDefaultUiPending: false,
        overwriteDefaultUiError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_OVERWRITE_DEFAULT_UI_FAILURE:
      return {
        ...state,
        overwriteDefaultUiPending: false,
        overwriteDefaultUiError: action.data.error,
      };

    case APP_SETTING_OVERWRITE_DEFAULT_UI_DISMISS_ERROR:
      return {
        ...state,
        overwriteDefaultUiError: null,
      };

    default:
      return state;
  }
}
